module.exports = __webpack_public_path__ + "img/file-zip.f809328a.svg";